/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_Nav_DemoInputs */

const tr_landing_finalcta_nav_demo = /** @type {(inputs: Landing_Finalcta_Nav_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı Demo`)
};

const en_landing_finalcta_nav_demo = /** @type {(inputs: Landing_Finalcta_Nav_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Demo`)
};

const de_landing_finalcta_nav_demo = /** @type {(inputs: Landing_Finalcta_Nav_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Demo`)
};

const ru_landing_finalcta_nav_demo = /** @type {(inputs: Landing_Finalcta_Nav_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Онлайн-демо`)
};

/**
* | output |
* | --- |
* | "Live Demo" |
*
* @param {Landing_Finalcta_Nav_DemoInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_nav_demo = /** @type {((inputs?: Landing_Finalcta_Nav_DemoInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_Nav_DemoInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_nav_demo(inputs)
	if (locale === "de") return de_landing_finalcta_nav_demo(inputs)
	if (locale === "ru") return ru_landing_finalcta_nav_demo(inputs)
	return tr_landing_finalcta_nav_demo(inputs)
});